import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";

// 3 Nov 2026: shown with the certificate. A student who finished the course rates it (1-5) and leaves a comment.
export default function ReviewBox({ slug }) {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [text, setText] = useState("");
    const [saved, setSaved] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        api.get(`/me/course/${slug}/review`).then((r) => {
            if (r.data.review) { setSaved(r.data.review); setRating(r.data.review.rating); setText(r.data.review.text || ""); }
        }).catch(() => {});
    }, [slug]);
    const submit = async (e) => {
        e.preventDefault();
        if (!rating) { toast.error("Tap the stars to rate the course."); return; }
        setBusy(true);
        try { const r = await api.post(`/me/course/${slug}/review`, { rating, text }); setSaved(r.data.review); toast.success("Thank you! Your review is live."); }
        catch (err) { toast.error(apiError(err.response?.data?.detail)); }
        setBusy(false);
    };
    const label = ["", "Not useful", "Could be better", "Good", "Very good", "Excellent"][hover || rating];
    return (
        <form onSubmit={submit} className="mx-auto max-w-4xl mt-6 bg-white border border-[#e0d6c2] rounded-2xl p-5 sm:p-6 text-center" data-testid="review-box">
            <h3 className="font-display font-semibold text-xl">{saved ? "Your review" : "How was the course?"}</h3>
            <p className="text-sm text-neutral-500 mt-1 max-w-xl mx-auto">{saved ? "You can change it any time. It shows on the course page with your first name." : "Your rating and a few words help other artists decide. It shows on the course page with your first name."}</p>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-1" onMouseLeave={() => setHover(0)}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <button type="button" key={i} onClick={() => setRating(i)} onMouseEnter={() => setHover(i)} aria-label={`${i} star${i > 1 ? "s" : ""}`} className="p-1" data-testid={`review-star-${i}`}>
                        <Star className="h-8 w-8" style={{ color: "#C88A24" }} fill={i <= (hover || rating) ? "#E5A83A" : "none"} />
                    </button>
                ))}
            </div>
            <p className="h-5 text-sm text-neutral-500">{label}</p>
            <textarea value={text} onChange={(e) => setText(e.target.value.slice(0, 1000))} rows={3} placeholder="What did you learn? What changed for your music?"
                className="mt-4 w-full border border-[#d9cfbc] rounded-xl px-4 py-3 text-sm text-center outline-none focus:border-[#C88A24]" data-testid="review-text" />
            <div className="mt-3 flex flex-col items-center gap-2">
                <span className="text-xs text-neutral-400">{text.length}/1000</span>
                <button type="submit" disabled={busy} className="btn-dark !py-2.5 !px-6 text-xs" data-testid="review-submit">{busy ? "Saving…" : saved ? "Update review" : "Post review"}</button>
            </div>
        </form>
    );
}
